import { Card } from "components/ui";
import PropTypes from "prop-types";
import BackgroundImg from "assets/images/dashbord_graphic.png";

const DashboardItem = ({ backgroundColor, onClick, children, className, ariaLabel }) => (
  <Card
    className={`dashboard-card ${className}`}
    style={{
      backgroundColor,
      backgroundImage: `url(${BackgroundImg})`
    }}
    onClick={onClick}
    role="link"
    tabIndex={0}
    aria-label={ariaLabel}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick?.(e);
      }
    }}
  >
    <div className="dashboard-layout">{children}</div>
  </Card>
);

DashboardItem.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  ariaLabel: PropTypes.string
};
export default DashboardItem;
